module.exports = __webpack_public_path__ + "static/media/7-custom-cut-passepartout-board-for-ikea -Ribba-frame-(36in-x-27in-91cm-x61cm).3079fbf1.webp";